var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconEye = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m16.07 9.46-.012.027a.153.153 0 0 1 .011-.028Zm-.418-.478c.128.287.219.533.278.722-.053.08-.122.177-.21.29a9.348 9.348 0 0 1-1.583 1.536C12.72 12.63 10.893 13.5 9 13.5c-1.893 0-3.721-.87-5.137-1.97A9.348 9.348 0 0 1 2.28 9.993a4.485 4.485 0 0 1-.21-.29c.06-.188.15-.434.278-.72.291-.656.74-1.454 1.351-2.218C4.923 5.235 6.651 4 9 4s4.078 1.236 5.3 2.765a10.36 10.36 0 0 1 1.352 2.217Zm-13.71.505a.143.143 0 0 1-.011-.028l.011.028ZM18 9.875C18 11 13.97 15.5 9 15.5S0 11 0 9.875 2.7 2 9 2s9 6.75 9 7.875ZM9 12.35a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2Z",
  clipRule: "evenodd"
})));
export default SvgIconEye;